import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/lab/Slider';
import InputLabel from '@material-ui/core/InputLabel';
import { styles } from '../../styles/slider-styles';
import { indigo } from '@material-ui/core/colors';

class StepSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 2,
    };
  }
  handleChange = (event, value) => {
    console.log(event, value, "handleChange");
    this.setState({ value, });
  };
  onDragEnd = (event) => {
    event.target.name = "cols";
    event.target.value = this.state.value;
    this.props.onChange(event);
  }
  componentWillUpdate(prevProps) {
    if(prevProps !== this.props) {
      this.setState({ value: this.props.cols})
    }
  }
  render() {
    const { classes } = this.props;
    const { value } = this.state;
    const rootClass = () => {
      if(!this.props.active) {
        return classes.inactive;
      } else {
        return classes.root;
      }
    }
    return (
      <div className={rootClass()}>
        <InputLabel className={classes.inputLabel} disabled={this.props.disabled}>Columns: {this.state.value}</InputLabel>
        <Slider
          disabled={this.props.disabled}
          classes={{ container: classes.slider, trackBefore: classes.trackBefore, thumb: classes.thumb }}
          value={this.state.value}
          min={2}
          max={6}
          step={2}
          onChange={this.handleChange}
          onDragEnd={this.onDragEnd}
        />
      </div>
    );
  }
}

StepSlider.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StepSlider);



// WEBPACK FOOTER //
// ./src/components/Settings/StepSlider.js